var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHowToLikeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.629.266C6.2.266 7.343 1.376 8 2.166c.657-.819 1.8-1.9 3.371-1.9 2.172 0 3.943 1.812 3.943 4.033 0 .525-.085 1.022-.286 1.52-.371.963-2.542 3.33-5.085 6.077-.629.672-1.172 1.286-1.486 1.607a.603.603 0 01-.457.204.51.51 0 01-.429-.204c-.285-.35-.857-.935-1.485-1.607C3.514 9.12 1.372 6.753 1 5.818a3.981 3.981 0 01-.286-1.52C.714 2.078 2.486.266 4.63.266z",
    fill: "url(#howToLikeIcon_svg__paint0_linear_1763_29060)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "howToLikeIcon_svg__paint0_linear_1763_29060",
    x1: 15.314,
    y1: 13.707,
    x2: 0.714,
    y2: 13.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#98D3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#92E1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DECE0"
  })))));
}

export default SvgHowToLikeIcon;